module.exports = __webpack_public_path__ + "static/media/Inverness.5a66393d.pdf";